export const config = {
  appName: "enrich-ui",
  basename: document.baseURI,
};
